// extracted by mini-css-extract-plugin
export default {"description-heading":"agent-management_description-heading__wgd05","list-title":"agent-management_list-title__GAzR0"};